module.exports = __webpack_public_path__ + "img/img_haoyunbaoshi@2x.2f3d0dc8.png";